import React, { useState } from "react";
import {
  Avatar,
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
  IconButton,
  Tooltip,
  Tab,
  Collapse,
  Autocomplete,
  Grid,
  FormControl,
  TablePagination,
} from "@mui/material";
import Heading from "../../../components/Heading";
import CommonButton from "../../../components/common/Button";
import CommonModal from "../../../components/common/Modal";
import { FaEdit, FaEye, FaPlus, FaShare } from "react-icons/fa";
import TableSearch from "../../../components/common/Table/TableSearch";
import { MdDelete } from "react-icons/md";
import { VscFilter } from "react-icons/vsc";
import Input from "../../../components/common/Input";
import { productStockList, uploadBulkStock } from "../../../Service/stock.service";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/common/Table/Pagination";
import moment from "moment";
import { TableRowsLoader } from "../../../components/common/Table/TableSkeleton";
import { useFormik } from "formik";
import { stockFilterInitialValues } from "../../../helper/initialValues";
import { sizeDropdown } from "../../../Service/size.service";
import { warehouseDropDown } from "../../../Service/warehouse.service";
import { getDesignFromStock, getSurfaceForStock } from "../../../Service/salesOrder.service";
import { RiFileExcel2Line } from "react-icons/ri";
import { notificationSuccess } from "../../../state/Action/NotificationAction";

const Stock = () => {
  const [isModalOpen, setIsModalOpen] = useState({
    open: false,
    currentComponent: "",
    para: "",
    head: "",
  });

  const { user } = useSelector((state) => state?.root?.auth);
  console.log(user);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [stockData, setStockData] = useState([]);
  const [search, setSearch] = useState('');
  const [totalData, setTotalData] = useState(0)
  const [sortDate, setSortDate] = useState(false);
  const [shortKey, setShortKey] = useState('createdAt');
  const [sortBy, setSortBy] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [sizeData, setSizeData] = useState([]);
  const [surfaceData, setSurfaceData] = useState([]);
  const [designData, setDesignData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [stockFile, setStockFile] = useState(null);

  const formik = useFormik({
    initialValues: stockFilterInitialValues,

    onSubmit: async (values) => {
      getStockList();
    }
  });

  const handleSubmitStockUpload = async () => {
    try {
      if (stockFile) {
        const formData = new FormData();
        formData.append('stockFile', stockFile);
        const uploadData = await uploadBulkStock(formData);
        if (uploadData?.status) {
          dispatch(notificationSuccess({ show: true, message: uploadData?.message, type: "success" }));
          setIsModalOpen({ open: false, currentComponent: "" });
          getStockList();
        } else {
          dispatch(notificationSuccess({ show: true, message: uploadData?.message, type: "error" }));
        }

      } else {
        dispatch(notificationSuccess({ show: true, message: "Please select file", type: "error" }));
      }
    }
    catch (error) {
      console.log(error);
    }

  };

  const getSizeDropdownData = async () => {
    let res = await sizeDropdown();
    if (res?.status) {
      setSizeData(res.data);
    } else {
      setSizeData([]);
    }
  };

  const getWarehouseDropdownData = async () => {
    let res = await warehouseDropDown();
    if (res?.status) {
      setWarehouseData(res.data);
    } else {
      setWarehouseData([]);
    }
  };

  const getSurfaceList = async (id) => {
    const payload = true;
    let res = await getSurfaceForStock(id, payload);
    if (res?.status) {
      setSurfaceData(res.data);
    } else {
      setSurfaceData([]);
    }
  }

  const getDesignList = async (size, id) => {
    const payload = true;
    let res = await getDesignFromStock(size, id, payload);
    if (res?.status) {
      setDesignData(res.data);
    } else {
      setDesignData([]);
    }
  }

  const getStockList = async () => {
    setStockData(null);
    let query = `?search=${search}&page=${page + 1}&perPageSize=${rowsPerPage}&orderBy=${shortKey}&sortFlag=${sortBy}&sizeId=${formik.values.sizeId}&surfaceId=${formik.values.surfaceId}&designId=${formik.values.designId}&warehouseId=${formik.values.warehouseId}&location=${formik.values.location}&batchNumber=${formik.values.batchNumber}`;
    let res = await productStockList(query);
    if (res?.status) {
      setStockData(res?.data);
      setTotalData(res?.total);
      setTotalPages(Math.ceil(res?.total / rowsPerPage));
    } else {
      setStockData([]);
      setTotalPages(0)
    }
  }

  useEffect(() => {
    getStockList();
  }, [search, page, rowsPerPage, sortBy, shortKey]);

  const handleSortClick = (name, by) => {
    switch (name) {
      case 'createdAt':
        setSortBy(!by)
        setSortDate((current) => !current)
        setShortKey('createdAt')
        break;

      default:
        setSortBy(!sortDate)
        setSortDate(false)
        setShortKey('createdAt')
        break;
    }
  };

  const handleFilterClick = () => {
    if (showFilter === true) {
      formik.resetForm();
      setShowFilter(!showFilter);
    } else {
      getSizeDropdownData();
      getWarehouseDropdownData();
      setShowFilter(!showFilter);
    }
  };

  return (
    <>
      <Stack gap={2}>
        <Heading head={"Stock Management"} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <TableSearch search={search} setSearch={setSearch} setPage={setPage} />
          <Box display="flex" gap={1}>
            <CommonButton
              buttonName="Export"
              endIcon={<FaShare />}
              onClick={() => navigation("/view-stock-report")}
            />
            {user && user?.role === 1 && (
              <Tooltip title="Bulk Upload stock - Excel File">
                <CommonButton
                  buttonName="Upload"
                  startIcon={<RiFileExcel2Line />}
                  onClick={() => {
                    setIsModalOpen({
                      open: true,
                      currentComponent: "uploadStock",
                    });
                  }}
                />
              </Tooltip>
            )}
            <CommonButton
              buttonName="Stock"
              onClick={() => {
                setIsModalOpen({
                  open: true,
                  currentComponent: "AddStock",
                });
              }}
              startIcon={<FaPlus />}
            />
            <Tooltip title="Filter">
              <CommonButton
                variant="contained"
                buttonName={<VscFilter />}
                onClick={() => handleFilterClick()}
                color="white"
                sx={{ marginTop: "10px" }}
              />
            </Tooltip>
          </Box>

        </Box>
        <Box>
          <Collapse in={showFilter}>
            <Grid
              container
              spacing={0.3}
              className="border_card"
              gap={2}
              p={1.5}
              alignItems={"center"}
            >
              <Grid item xs={4} md={3} lg={2}>
                <FormControl fullWidth variant="standard">
                  <Autocomplete
                    options={sizeData}
                    getOptionLabel={(option) => option.sizeName || ""}
                    value={
                      sizeData.find((role) => role.id === formik.values.sizeId) || null
                    } // Match the current value with roledata
                    onChange={(event, newValue) => {
                      // Ensure newValue is not undefined or null
                      formik.setFieldValue('sizeId', newValue ? newValue.id : '');
                      getSurfaceList(newValue?.id);
                    }}
                    renderInput={(params) => (
                      <Input
                        {...params}
                        labelinput="Size"
                        error={formik.touched.sizeId && Boolean(formik.errors.sizeId)}
                        helperText={formik.touched.sizeId && formik.errors.sizeId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4} md={3} lg={2}>
                <FormControl fullWidth variant="standard">
                  <Autocomplete
                    options={surfaceData}
                    getOptionLabel={(option) => option.surfaceName || ""}
                    value={
                      surfaceData.find((role) => role.id === formik.values.surfaceId) || null
                    } // Match the current value with roledata
                    onChange={(event, newValue) => {
                      // Ensure newValue is not undefined or null
                      formik.setFieldValue('surfaceId', newValue ? newValue.id : '');
                      getDesignList(formik.values.sizeId, newValue?.id);
                    }}
                    renderInput={(params) => (
                      <Input
                        {...params}
                        labelinput="Surface"
                        error={formik.touched.surfaceId && Boolean(formik.errors.sizesurfaceIdId)}
                        helperText={formik.touched.surfaceId && formik.errors.surfaceId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4} md={3} lg={2}>
                <FormControl fullWidth variant="standard">
                  <Autocomplete
                    options={designData}
                    getOptionLabel={(option) => option.productName || ""}
                    value={
                      designData.find((role) => role.id === formik.values.designId) || null
                    } // Match the current value with roledata
                    onChange={(event, newValue) => {
                      formik.setFieldValue('designId', newValue ? newValue.id : '');
                    }}
                    renderInput={(params) => (
                      <Input
                        {...params}
                        labelinput="Design"
                        error={formik.touched.designId && Boolean(formik.errors.designId)}
                        helperText={formik.touched.designId && formik.errors.designId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4} md={3} lg={2}>
                <FormControl fullWidth variant="standard">
                  <Autocomplete
                    options={warehouseData}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      warehouseData.find((role) => role.id === formik.values.warehouseId) || null
                    } // Match the current value with roledata
                    onChange={(event, newValue) => {
                      formik.setFieldValue('warehouseId', newValue ? newValue.id : '');
                    }}
                    renderInput={(params) => (
                      <Input
                        {...params}
                        labelinput="Warehouse"
                        error={formik.touched.warehouseId && Boolean(formik.errors.warehouseId)}
                        helperText={formik.touched.warehouseId && formik.errors.warehouseId}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4} md={3} lg={2}>
                <Input labelinput="Batch No" type="text" {...formik.getFieldProps("batchNumber")} />
              </Grid>
              <Grid item xs={4} md={3} lg={2}>
                <Input labelinput="Location" type="text" {...formik.getFieldProps("location")} />
              </Grid>
              <Stack gap={1} flexDirection={"row"}>
                <Box>
                  <CommonButton color="primary" buttonName={"Filter"} onClick={formik.handleSubmit} />
                </Box>
                <Box>
                  <CommonButton
                    buttonName={"Clear"}
                    color="white"
                    onClick={() => {
                      formik.resetForm();
                      setShowFilter(false);
                      formik.handleSubmit();
                    }}
                  />
                </Box>
              </Stack>
            </Grid>
          </Collapse>
        </Box>
        <Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Size</TableCell>
                  <TableCell>Surface</TableCell>
                  <TableCell>Product Name</TableCell>
                  <TableCell>Warehouse</TableCell>
                  <TableCell>Batch Number</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell>Stock On Hand</TableCell>
                  <TableCell>Commited Stock</TableCell>
                  <TableCell>Available For Sale</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell sx={{ textAlign: "end" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stockData === null ? (
                  // Display skeleton loader when data is loading
                  <TableRowsLoader columnsNum={11} />
                ) : stockData.length === 0 ? (
                  // Display "No data available" message when data is empty
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                ) : (stockData?.map((row) => (
                  <TableRow key={row.id} sx={{ cursor: "pointer" }} onClick={() => navigation("/view-stock", { state: { id: row.designId } })}>
                    <TableCell>
                      {row?.sizeName}
                    </TableCell>
                    <TableCell>
                      {row?.surfaceName}
                    </TableCell>
                    <TableCell>
                      {row?.productName}
                    </TableCell>
                    <TableCell>
                      {row?.warehouseName || "-"}
                    </TableCell>
                    <TableCell>
                      {row?.batchNumber}
                    </TableCell>
                    <TableCell>
                      {row?.location || "-"}
                    </TableCell>
                    <TableCell>
                      {row?.stock}
                    </TableCell>
                    <TableCell>
                      {row?.commitedstock}
                    </TableCell>
                    <TableCell>
                      {row?.availableforsale}
                    </TableCell>
                    <TableCell>
                      {moment(row?.createdAt).format('DD-MM-YYYY')}
                    </TableCell>
                    <TableCell onClick={(e) => e.stopPropagation()}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          justifyContent: "flex-end",
                        }}
                      >
                        <Tooltip title="View Details">
                          <IconButton
                            size="small"
                            onClick={() => navigation("/view-stock", { state: { id: row.designId } })}
                          >
                            <FaEye />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit Details">
                          <IconButton
                            onClick={() => {
                              setIsModalOpen({
                                open: true,
                                currentComponent: "AddStock",
                                id: row.id,
                              });
                            }}
                            size="small"
                          >
                            <FaEdit />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Stack>
      {stockData !== null && (

        <Pagination
          totalData={totalData} // Total number of data items
          page={page} // Current page number
          setPage={setPage} // Function to update current page number
          rowsPerPage={rowsPerPage} // Number of rows per page
          setRowsPerPage={setRowsPerPage} // Function to update number of rows per page
        />)}
      <CommonModal
        modalOpen={isModalOpen}
        handleClose={() => {
          setIsModalOpen({ open: false, currentComponent: "", id: "" });
          getStockList();
        }}
        stockFile={stockFile}
        setStockFile={setStockFile}
        handelClick={handleSubmitStockUpload}
      />
    </>
  );
};

export default Stock;
